<template>
<input ref="autocomplete" type="text" :class="classname" :id="id" :restrictAddress="restrictAddress" :placeholder="placeholder" v-model="autocompleteText" @focus="onFocus()" @blur="onBlur()" @change="onChange" @keypress="onKeyPress" @keyup="onKeyUp" />
</template>

<script>
// const ADDRESS_COMPONENTS = {
//   subpremise: 'short_name',
//   street_number: 'short_name',
//   route: 'long_name',
//   locality: 'long_name',
//   administrative_area_level_1: 'short_name',
//   administrative_area_level_2: 'long_name',
//   country: 'long_name',
//   postal_code: 'short_name'
// }

import Cart from '@/cart'

const CITIES_TYPE = ['locality', 'administrative_area_level_3']
const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  'administrative_area_level_1', 'administrative_area_level_2'
]

export default {
  name: 'VueGoogleAutocomplete',

  props: {
    id: {
      type: String,
      required: true
    },

    classname: String,

    placeholder: {
      type: String,
      default: 'Start typing'
    },

    types: {
      type: String,
      default: 'address'
    },

    country: {
      type: [String, Array],
      default: null
    },

    enableGeolocation: {
      type: Boolean,
      default: false
    },

    geolocationOptions: {
      type: Object,
      default: null
    },

    restrictAddress: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      Cart: Cart,
      autocomplete: null,
      autocompleteText: '',
      lastValidAutocompleteText: '',
      lastPlace: null,
      geolocation: {
        geocoder: null,
        loc: null,
        position: null
      }
    }
  },

  watch: {
    autocompleteText: function(newVal, oldVal) {
      this.$emit('inputChange', {
        newVal,
        oldVal
      }, this.id)
    },
    country: function(newVal, oldVal) {
      this.autocomplete.setComponentRestrictions({
        country: this.country === null ? [] : this.country
      })
    },
    // restrictAddress: function(newVal, oldVal) {
    //   console.log('cart delivery code restrictAddress changed')
    //   console.log('--------------------', newVal, oldVal)
    //   if (newVal) {
    //     this.restrictAutocompleteLocation()
    //   } else {
    //     this.removeAutocompleteLocationRestriction()
    //   }
    // },
    // 'Cart.data.delivery.code': function (newVal, oldVal) {
    //     console.log('cart delivery code changed, checking address restriction')
    //     if (this.restrictAddress) {
    //       this.restrictAutocompleteLocation()
    //     } else {
    //       this.removeAutocompleteLocationRestriction()
    //     }
    // }
  },

  mounted: function() {
    
    console.log('GoogleMapsAutocomplete:mounted: restrictAddress:', this.restrictAddress)

    // google docs
    // https://developers.google.com/maps/documentation/javascript/reference/places-widget#AutocompleteOptions
    // https://developers.google.com/places/supported_types#table3

    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete)

    this.autocomplete.addListener('place_changed', this.onPlaceChanged)
    if (this.restrictAddress) {
      this.restrictAutocompleteLocation()
    } else {
      this.removeAutocompleteLocationRestriction()
    }
    this.setPlaceFields()
    this.setTypes()
  },

  methods: {
    restrictAutocompleteLocation() {
      console.log('restrictAddress: restricting')
        // this will get bounds of a square over the circle! It's not possible to restrict to a circle. I have tried and failed a lot, even though docs say it is possible
        let circle = new google.maps.Circle({
          center: new google.maps.LatLng({lat: 50.069829, lng: 14.433023}), // provoni headquarters
          radius: 10000 // 10 000 m
        })
        console.log('restricting bounds')
        this.autocomplete.setBounds(circle.getBounds())
        this.autocomplete.setOptions({
          strictBounds: true
        })
    },
    removeAutocompleteLocationRestriction() {
      console.log('restrictAddress: removing restriction')
      this.autocomplete.setOptions({
        strictBounds: false
      })
    },
    setPlaceFields() {
      this.autocomplete.setOptions({
        fields: [
          'address_components',
          'formatted_address',
          'geometry.location',
          'id',
          'place_id'
        ]
      })
    },
    setComponentRestrictions() {
      this.autocomplete.setOptions({
        componentRestrictions: {
          country: 'CZ'
        }
      })
    },
    setTypes() {
      this.autocomplete.setOptions({
        types: ['address']
      })
    },
    onPlaceChanged() {
      let place = this.autocomplete.getPlace()
      console.log('onPlaceChanged:', place, this.$refs.autocomplete.value)
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        this.$emit('no-results-found', place, this.id)
        return
      }

      if (place.address_components !== undefined) {
        
        var formattedResult = this.formatResult(place)
        console.log('formattedResult:', formattedResult)
        this.$emit('placechanged', formattedResult, place, this.id)

        // update autocompleteText then emit change event
        
        
        
        // store only valid address
        if (formattedResult.street_number && formattedResult.street_number.short_name) {
          this.autocompleteText = place.formatted_address
          console.log('storing lastValidAutocompleteText', this.autocompleteText)
          this.lastValidAutocompleteText = this.autocompleteText
          this.lastPlace = place
          
        } else {
          // HACK when Google doesn't return street number
          // try to parse the address
          console.log('trying to parse address')
          var regex_street_number = /[a-zA-Zá-žÁ-Ž0-9\/\.]+$/g
          var userInput = this.$refs.autocomplete.value
          var addressParts = userInput.split(', ')
          var streetPart = addressParts[0]
          
          var streetContainsNumber = /\d/.test(streetPart)
          
          if (streetContainsNumber) {
            var streetNumber = regex_street_number.exec(streetPart)[0]
            console.log('parsed street number:', streetNumber)
            
            // inject street number to the google api resupt
            formattedResult.street_number = {
              short_name: streetNumber,
              long_name: streetNumber
            }
            
            // keep the user's input
            this.autocompleteText = document.getElementById(this.id).value
            console.log('storing lastValidAutocompleteText', this.autocompleteText)
            this.lastValidAutocompleteText = this.autocompleteText
            this.lastPlace = place
          } else {
            console.log('street does not contain number')
          }
          
          
          
        }
        
        this.onChange()
      }
    },
    updateCoordinates(value) {
      if (!value && !(value.lat || value.lng)) return
      if (!this.geolocation.geocoder) this.geolocation.geocoder = new google.maps.Geocoder()
      this.geolocation.geocoder.geocode({
        'location': value
      }, (results, status) => {
        if (status === 'OK') {
          results = this.filterGeocodeResultTypes(results)
          if (results[0]) {
            this.$emit('placechanged', this.formatResult(results[0]), results[0], this.id)
            this.update(results[0].formatted_address)
          } else {
            this.$emit('error', 'no result for provided coordinates')
          }
        } else {
          this.$emit('error', 'error getting address from coords')
        }
      })
    },
    geolocate() {
      this.updateGeolocation((geolocation, position) => {
        this.updateCoordinates(geolocation)
      })
    },
    updateGeolocation(callback = null) {
      if (navigator.geolocation) {
        let options = {}
        if (this.geolocationOptions) Object.assign(options, this.geolocationOptions)
        navigator.geolocation.getCurrentPosition(position => {
          let geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.geolocation.loc = geolocation
          this.geolocation.position = position

          if (callback) callback(geolocation, position)
        }, err => {
          this.$emit('error', 'Cannot get Coordinates from navigator', err)
        }, options)
      }
    },
    biasAutocompleteLocation() {
      if (this.enableGeolocation) {
        this.updateGeolocation((geolocation, position) => {
          let circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          })
          this.autocomplete.setBounds(circle.getBounds())
        })
      }
    },
    formatResult(place) {
      let returnData = {};
      for (let i = 0; i < place.address_components.length; i++) {
          let addressType = place.address_components[i].types[0];
          let val = {
            long_name: place.address_components[i].long_name, //[ADDRESS_COMPONENTS[addressType]];
            short_name: place.address_components[i].short_name
          }
          // console.log('VALX:', val)
          returnData[addressType] = val;
      }
      
      returnData['formatted_address'] = place.formatted_address
      returnData['id'] = place.id
      returnData['place_id'] = place.place_id

      returnData['latitude'] = place.geometry.location.lat()
      returnData['longitude'] = place.geometry.location.lng()
      console.log('formatResult', returnData)
      return returnData
      // let returnData = {}
      // for (let i = 0; i < place.address_components.length; i++) {
      //   let addressType = place.address_components[i].types[0]
      // 
      //   if (ADDRESS_COMPONENTS[addressType]) {
      //     let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]]
      //     returnData[addressType] = val
      //   }
      // }
      // 
      // returnData['latitude'] = place.geometry.location.lat()
      // returnData['longitude'] = place.geometry.location.lng()
      // return returnData
    },
    filterGeocodeResultTypes(results) {
      if (!results || !this.types) return results
      let output = []
      let types = [this.types]
      if (types.includes('(cities)')) types = types.concat(CITIES_TYPE)
      if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE)

      for (let r of results) {
        for (let t of r.types) {
          if (types.includes(t)) {
            output.push(r)
            break
          }
        }
      }
      return output
    },


    onFocus() {
      // this.biasAutocompleteLocation()
      this.$emit('focus')
    },
    onBlur() {
      console.log('XXXXXXXX')
      console.log('this.autocompleteText:', this.autocompleteText)
      console.log('this.lastValidAutocompleteText:', this.lastValidAutocompleteText)
      console.log('this.lastPlace:', this.lastPlace)
      if (this.lastValidAutocompleteText && this.lastPlace) {
        this.autocompleteText = this.lastValidAutocompleteText
        this.place = this.lastPlace
      } else {
        this.autocompleteText = this.lastValidAutocompleteText
      }
      
      this.$emit('blur')
    },
    onChange() {
      this.$emit('change', this.autocompleteText)
    },
    onKeyPress(event) {
      this.$emit('keypress', event)
    },
    onKeyUp(event) {
      this.$emit('keyup', event)
    },
    clear() {
      this.autocompleteText = ''
    },
    focus() {
      this.$refs.autocomplete.focus()
    },
    blur() {
      this.$refs.autocomplete.blur()
    },
    update(value) {
      this.autocompleteText = value
    }
  }
}
</script>
